<template>
    <div class="modal fade" id="eulaModal" tabindex="-1" role="dialog" aria-labelledby="eulaModalLabel" data-backdrop="static">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h1>{{eulaAgreement.header}}</h1>
                </div>
                <div class="modal-body">
                    <div class="eula-body">
                        <div v-for="(agreement, index) in eulaAgreement.agreements" class="agreement">
                            <toggle-button :disabled="onRequest" :value="agreement.check" @change="onChangeAgreement(agreement, index)"
                                           :labels="{checked: 'Yes', unchecked: 'No'}" :width="80" :color="{checked: '#31B404', unchecked: '#DF0101'}"/>
                            <span class="agreement-text" style="display: block">{{agreement.text}}</span>
                        </div>
                        <br/><br/>
                        <p style="font-weight: bold">You can check the Privacy Policy <a
                            href="https://www.comodo.com/repository/privacy-policy.php" target="_blank">here</a></p>
                        <button id="agree-button" :disabled="!buttonActive" @click="onAgreeClickled"> AGREE TO ALL & CONTINUE </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Constants from '@/utils/constants'
    import Common from '@/utils/Common.vue'

    export default {
        name: "user-eula",
        mixins: [Common],
        data() {
            return {
                eulaAgreement: {},
                loginLoading: true,
                buttonActive: false,
                onRequest: false,
                eula_user_id: null
            }
        },
        methods: {
            showModal(eula_user_id){
                this.eulaAgreement = {
                    header: "Specific Terms For Customer",
                    introductions: [
                        {
                            "text": "Please note that all data on Valkyrie Threat Intelligence is collected by Comodo from public internet sources or provided to Comodo from third party affiliates",
                        },
                        {
                            "text": "All the data on Valkyrie Threat Intelligence is stored encrypted manner with latest industry standards in highly secure environments."
                        }
                    ],
                    agreements: []
                };

                this.eula_user_id = eula_user_id;


                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/eula_contract/get')
                    .then(response => {
                        var agreementsResponse = response.data.data;
                        for (var i = 0; i < agreementsResponse.length; i++) {
                            agreementsResponse[i].check = false;
                        }
                        this.eulaAgreement.agreements = agreementsResponse;
                        $('#eulaModal').modal('show');
                    }, response => {

                    });
            },
            hideModal() {
                this.eulaAgreement.agreements = [];
                $('#eulaModal').modal('hide');
            },
            onChangeAgreement(agreement, index) {
                this.onRequest = true;
                this.eulaAgreement.agreements[index].check = !this.eulaAgreement.agreements[index].check;
                var body = {
                    agreement: agreement,
                    user_id: this.eula_user_id
                }
                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/eula_contract/post', body)
                    .then(response => {
                        this.onRequest = false;
                        this.buttonActive = checkAgreement(this.eulaAgreement.agreements);
                    }, response => {
                        this.onRequest = false;
                        // console.log('Agreement Check Failed' + agreement);
                    });
            },
            onAgreeClickled(){
                this.$emit("agreeClicked", {
                });
            }
        },
        mounted() {
            $('#eulaModal').modal({show: false});
        }
    }

    function checkAgreement(agreementList){
        for (var i in agreementList) {
            if (!agreementList[i].check) {
                return false;
            }
        }
        return true;
    }

</script>

<style scoped>

    .modal-content {
        background-color: white !important;
    }

    .eulaModal p {
        font-family: 'Digital-Serial-Bold' !important;
    }

    .vue-js-switch {
        margin-bottom: 0;
    }

    .agreement-text {
        width: 95%;
        position: relative;
        left: 5%;
        padding: 5px 0;
    }

    .eula-body {
        position: relative;
    }

    #agree-button {
        background-color: limegreen;
        border:none;
        height: 50px;
        color: white;
        padding: 0 15px;
        font-family: 'Digital-Serial-Bold' !important;
        position: absolute;
        right: 1%;
        bottom: -12.5px;
    }

    #agree-button:disabled {
        background-color: darkgrey;
    }

    h1{
        color: limegreen;
        font-family: 'Digital-Serial-Bold' !important;
    }

    p, span{
        font-family: 'Digital-Serial-Bold' !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/modals/EulaModal.vue